var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDispatcherShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 39.1021C77.5 60.3651 60.263 77.6021 39 77.6021C17.737 77.6021 0.5 60.3651 0.5 39.1021C0.5 17.8391 17.737 0.602112 39 0.602112C60.263 0.602112 77.5 17.8391 77.5 39.1021Z",
    fill: "#F8F9FE",
    stroke: "#0025F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1406 58.1018V49.1625L25.9285 46.6392H33.0799L34.9062 49.1625V58.1018",
    fill: "#DBE1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3238 49.1621H24.7363V58.1014H28.3238V49.1621Z",
    fill: "#DBE1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8677 49.1621H24.1406L25.9285 46.7783H33.0799L34.8677 49.1621Z",
    fill: "#DBE1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3124 49.1621H24.1406L25.2333 46.7783H29.6036L28.3124 49.1621Z",
    fill: "#DBE1FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0469 40.2889H37.8488V34.2643L34.8672 31.3047H33.0469",
    fill: "#FFF3E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9062 31.2847V36.6488H37.8494V34.2644L34.9062 31.2847Z",
    fill: "#F8F9FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8481 36.6479H36.0605V40.2238H37.8481V36.6479Z",
    fill: "#FFF3E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2926 44.9902H27.7168V46.7778H31.2926V44.9902Z",
    fill: "#FFF3E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0479 30.0918C33.0479 28.117 31.4987 26.5161 29.524 26.5161C27.5492 26.5161 26 28.117 26 30.0918V45.0125H33.0479V30.0918Z",
    fill: "#DBE1FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2926 34.2637H27.7168V39.627H31.2926V34.2637Z",
    fill: "#DBE1FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5043 31.8798C30.4916 31.8798 31.2919 31.0795 31.2919 30.0922C31.2919 29.105 30.4916 28.3047 29.5043 28.3047C28.5171 28.3047 27.7168 29.105 27.7168 30.0922C27.7168 31.0795 28.5171 31.8798 29.5043 31.8798Z",
    fill: "#FFF3E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5043 34.2637H27.7168V39.627H29.5043V34.2637Z",
    fill: "#DBE1FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.702 26.724C30.3287 26.5918 29.9615 26.5161 29.5429 26.5161C27.5681 26.5161 26 28.117 26 30.0918V45.0125H28.3235V30.0919C28.3235 28.5357 29.3141 27.2154 30.702 26.724Z",
    fill: "#DBE1FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0195 27.8577L49.4517 20.7548C50.0704 20.5297 50.7543 20.8486 50.9795 21.4673C51.2046 22.0859 50.8856 22.7698 50.267 22.995L32.8348 30.0979",
    fill: "#FFF3E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4644 45.5864H40.25V47.374H60.4644V45.5864Z",
    fill: "#DBE1FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2722 29.4956H33.0803L32.4844 27.7077L34.2722 27.1118V29.4956Z",
    fill: "#FFF3E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9787 45.5864H40.25V47.374H47.9787V45.5864Z",
    fill: "#DBE1FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8986 47.3745H40.8281V56.9094H59.8986V47.3745Z",
    fill: "#FFF3E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9799 47.3745H40.8281V56.9094H47.9799V47.3745Z",
    fill: "#FFF3E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4783 57.4905H40.2461V46.7935H60.4783V57.4905ZM41.4078 56.3287H59.3166V47.9553H41.4078V56.3287Z",
    fill: "#000730"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1363 49.1958H44.9746V55.2369H46.1363V49.1958Z",
    fill: "#000730"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8141 49.1958H42.6523V55.2369H43.8141V49.1958Z",
    fill: "#000730"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5367 49.1958H47.375V55.2369H48.5367V49.1958Z",
    fill: "#000730"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9391 49.1958H49.7773V55.2369H50.9391V49.1958Z",
    fill: "#000730"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3395 49.1958H52.1777V55.2369H53.3395V49.1958Z",
    fill: "#000730"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6637 49.1958H54.502V55.2369H55.6637V49.1958Z",
    fill: "#000730"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0641 49.1958H56.9023V55.2369H58.0641V49.1958Z",
    fill: "#000730"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3027 45.0901V44.3931H58.141V45.0901H42.4961V44.3931H41.3343V45.0901H40.25V46.2519H60.4644V45.0901H59.3027Z",
    fill: "#000730"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7628 36.1059H50.9377V34.8667H49.776V36.1059H48.9631L41.334 42.3312V43.7734H42.4957V42.8827L49.377 37.2677H51.3449L58.1406 42.8805V43.7734H59.3024V42.3333L51.7628 36.1059Z",
    fill: "#000730"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5035 32.4606C28.1974 32.4606 27.1348 31.3981 27.1348 30.0919C27.1348 28.7857 28.1973 27.7231 29.5035 27.7231C30.8097 27.7231 31.8723 28.7857 31.8723 30.0919C31.8723 31.3981 30.8096 32.4606 29.5035 32.4606ZM29.5035 28.885C28.838 28.885 28.2965 29.4264 28.2965 30.092C28.2965 30.7576 28.8379 31.299 29.5035 31.299C30.1691 31.299 30.7105 30.7576 30.7105 30.092C30.7105 29.4264 30.169 28.885 29.5035 28.885Z",
    fill: "#000730"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9391 25.9609H49.7773V34.2481H50.9391V25.9609Z",
    fill: "#000730"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8723 40.2075H27.1348V33.6821H31.8722C31.8723 33.6821 31.8723 40.2075 31.8723 40.2075ZM28.2965 39.0457H30.7104V34.8439H28.2965V39.0457Z",
    fill: "#000730"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 40.9077H28.3242V42.0694H30.8026V40.9077Z",
    fill: "#000730"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 42.6123H28.3242V43.774H30.8026V42.6123Z",
    fill: "#000730"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 48.0332H28.3242V49.1949H30.8026V48.0332Z",
    fill: "#000730"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 49.8921H28.3242V51.0538H30.8026V49.8921Z",
    fill: "#000730"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 51.5186H28.3242V52.6803H30.8026V51.5186Z",
    fill: "#000730"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 53.3779H28.3242V54.5397H30.8026V53.3779Z",
    fill: "#000730"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 55.2368H28.3242V56.3986H30.8026V55.2368Z",
    fill: "#000730"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8026 56.9399H28.3242V58.1017H30.8026V56.9399Z",
    fill: "#000730"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1826 29.5229H28.9434V30.6847H30.1826V29.5229Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5256 21.2686C51.1913 20.3501 50.1719 19.8747 49.2533 20.2091L49.243 20.2129L32.3427 27.099C31.5773 26.3487 30.5663 25.9355 29.4851 25.9355C28.3757 25.9355 27.3397 26.3694 26.5677 27.1572C25.8019 27.9385 25.3802 28.9808 25.3802 30.0921V45.6324H27.0066V46.097H25.635L23.5215 48.972V58.1018H24.6832V49.8146H27.6263V48.6529H25.198L26.2229 47.2588H32.7826L33.7856 48.6529H31.2664V49.8146H34.287V58.1018H35.4487V48.9753L33.378 46.097H31.8086V45.6324H33.5899V40.9079H38.3918V34.0219L35.1075 30.762H33.5899V30.4176L49.777 23.822V25.3404H50.9387V23.2817C51.5359 22.8231 51.7965 22.0128 51.5256 21.2686ZM30.6469 46.097H28.1685V45.6324H29.4077H30.6469V46.097ZM32.4283 44.4705H26.542V30.092C26.542 28.4127 27.8347 27.0972 29.4851 27.0972C31.1355 27.0972 32.4283 28.4127 32.4283 30.092V44.4705ZM35.4488 32.7375L37.2301 34.5056V36.106H35.4488V32.7375ZM34.2871 31.9237V37.2677H37.2302V39.7461H33.59V31.9237H34.2871ZM33.4961 29.2013C33.4108 28.7987 33.2677 28.4138 33.0708 28.0569L49.6595 21.2977C49.9737 21.1885 50.3197 21.3523 50.434 21.6659C50.5491 21.9825 50.3853 22.3339 50.0687 22.4491L50.0584 22.4528L33.4961 29.2013Z",
    fill: "#000730"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatcherShop);
export default __webpack_public_path__ + "static/media/dispatcher-shop.a052aeae451851d2f302e398dfbba32b.svg";
export { ForwardRef as ReactComponent };